import React, { type FC } from 'react';

import ABTest from '../../ab-test/ab-test';

export interface ABTestMinimizeNavProps {
  willTriggerFire?: boolean;
}

const ABTestMinimizeNav: FC<ABTestMinimizeNavProps> = ({ willTriggerFire }) => (
  <ABTest
    isAboveTheFold
    branchesToRender={['T_A', 'T_B']}
    testName="FY26_LucidchartMinimizeNav2"
    willTriggerFire={willTriggerFire}
  >
    <ABTest.Context.Consumer>
      {({ branch }) => {
        if (branch === 'T_B') {
          window.scrollTo(0, 70);

          return null;
        }
      }}
    </ABTest.Context.Consumer>
  </ABTest>
);

export default ABTestMinimizeNav;
